import { Inject, Injectable, NgZone } from '@angular/core'
import { Store } from '@ngrx/store'
import { MainViewActions } from './action-types'

// TODO this service acts as a bridge between old code and new with NgRx store
// TODO delete it after migration is finished

@Injectable()
export class MainViewActionsService {

    constructor(@Inject(Store) private store: Store, @Inject(NgZone) protected ngZone: NgZone) {
    }

    setAllIsEditingFalse(): void {
        this.ngZone.run(() => {
            this.store.dispatch(MainViewActions.setAllIsEditingFalse())
        })
    }

    setBlockRequests(data): void {
        this.store.dispatch(MainViewActions.setBlockRequests({
            blockRequests: data
        }))
    }

    setDepartments(departments): void {
        this.store.dispatch(MainViewActions.setDepartments({
            departments: departments
        }))
    }

    setSelectedDepartment(department): void {
        this.store.dispatch(MainViewActions.setSelectedDepartment({
            department: department
        }))
    }
}